import React from "react";
import { motion } from "framer-motion";

const VisaDetailLayout = ({ title, children }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
      className="min-h-screen px-6 py-20 bg-white text-gray-800 max-w-4xl mx-auto"
    >
      <h1 className="text-3xl md:text-4xl font-bold text-blue-700 mb-6 text-center">
        {title}
      </h1>
      <div className="space-y-6">{children}</div>
    </motion.div>
  );
};

export default VisaDetailLayout;
